﻿window.cBuilderEmailWidgetCtrlTextBoxNomStr = function cBuilderEmailWidgetCtrlTextBoxNomStr(option) {
    var Me = this;

    window.cBuilderEmailWidgetCtrlTextBox.call(this, option);

    this.nomWidget = "dxwidgetformtextboxnomstr"
    this.typChamp = "nom_str";
    this.nomBt = "Nom structure";
    this.titleBt = "Nom d'une structure<br/>Ce champ pourra être relié à votre base de données"
    this.labelCtrl = "Nom structure"

};